import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import {
  Box,
  Container,
  IconButton,
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import { config, mailtoHref, telHref } from "../config";

export function Footer() {
  const { t } = useTranslation(["landing", "common"]);
  const year = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={(theme) => ({
        mt: 10,
        py: 6,
        borderTop: `1px solid ${theme.palette.divider}`,
        background: theme.palette.mode === "dark"
          ? "linear-gradient(180deg, #141210 0%, #100E0C 100%)"
          : "linear-gradient(180deg, #F7F0E6 0%, #EFE5D6 100%)",
      })}
    >
      <Container maxWidth="lg">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={{ xs: 3, sm: 2 }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
        >
          <Stack spacing={0.5}>
            <Typography variant="h6">{config.brandName}</Typography>
            <Typography variant="body2" color="text.secondary">
              {t("footer.tagline")}
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <MuiLink href={mailtoHref()} color="inherit" underline="hover">
              {config.contactEmail}
            </MuiLink>
            <MuiLink href={telHref()} color="inherit" underline="hover">
              {config.contactPhone}
            </MuiLink>
          </Stack>

          <Stack direction="row" spacing={1}>
            {config.instagramUrl && (
              <IconButton
                component="a"
                href={config.instagramUrl}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={t("common:aria.instagram")}
                color="inherit"
              >
                <InstagramIcon />
              </IconButton>
            )}
            {config.facebookUrl && (
              <IconButton
                component="a"
                href={config.facebookUrl}
                target="_blank"
                rel="noreferrer noopener"
                aria-label={t("common:aria.facebook")}
                color="inherit"
              >
                <FacebookIcon />
              </IconButton>
            )}
          </Stack>
        </Stack>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: "block", mt: 4, textAlign: { xs: "left", sm: "center" } }}
        >
          © {year} {config.brandName}. {t("footer.rights")}
        </Typography>
      </Container>
    </Box>
  );
}
